import { render } from "./VariantListItem.vue?vue&type=template&id=206a45cc&lang=pug"
import script from "./VariantListItem.vue?vue&type=script&lang=js"
export * from "./VariantListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__